// extracted by mini-css-extract-plugin
export default {"customAttrRow":"CustomAttrRow_customAttrRow__ZmSfV","customAttrRemove":"CustomAttrRow_customAttrRemove__UH0xF"};